<template>
    <div class="quality__content">
        <NavSecond :banner="icon_stra"></NavSecond>
        <div class="qu_type animate__animated animate__fadeIn"><span>工艺品质</span></div>
<!--        <div class="wrapper__w  qu__culture">-->
<!--            <div class="bg" :style="{'background': 'url('+icon_af3+')', 'background-repeat': 'no-repeat',-->
<!--                    'background-size': '100% 100%'}">-->
<!--                <div class="title"><span>博采欧系高端工艺</span></div>-->
<!--                <div>为环保、安全、健康保驾护航</div>-->
<!--            </div>-->
<!--        </div>-->
        <div class="wrapper__w q_process__flow box__align" :style="{'background':'url('+icon_q01+')', 'background-size': '100% 100%', 'background-repeat': 'no-repeat'}">
            <div class="qu_type  animate__animated animate__fadeInUp">
                <span>博采欧系高端工艺</span>
                <div class="remd">为环保、安全、健康保驾护航</div>
            </div>
        </div>
        <div>
            <div class="wrapper__wpd relative" style="margin-bottom: 50px">
                <el-row :gutter="30" class="relative" style="z-index: 22">
                    <el-col :span="12">
                        <div style="width: 90%">
                            <div  class="wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s">
                                <div class="q_base__material--tit"><span>标准化成品</span></div>
                                <div class="q_base__material--des">户门外走廊、台阶、栏、立柱墙面阳角、地面等保护，防止以上既有物品损坏，积落灰尘等。</div>
                            </div>
                            <div class="q_base__material--img abs">
                                <img :src="icon_1">
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="q_base__material--imgbg animate__animated animate__fadeInUp">
                            <img :src="icon_2">
                        </div>
                    </el-col>
                </el-row>
                <div class="gray__bg" style="z-index: 11;right: 0;top: 50px;width: 40%;height: 255px"></div>
            </div>
            <div class="wrapper__w relative q__jj">
                <el-row :gutter="0">
                    <el-col :span="12" class="jj__left">
                        <img :src="icon_3">
                    </el-col>
                    <el-col :span="12" class="jj__right relative">
                        <div>
                            <div style="margin-left: 13%;" class="wow animate__fadeInUp" data-wow-delay=".5s" data-wow-duration="0.8s">
                                <div class="q_base__material--tit"><span>基建</span></div>
                                <div class="q_base__material--des" style="font-size: 22px;margin-bottom: 20px">
                                    独立基建团队管理体系</br>
                                    专业基建工艺
                                </div>
                                <div>
                                    1、专业基建团队、丰富的基建经验。</br>
                                    2、优化的平面方案、可靠的结构设计。</br>
                                    3、匠心的基建管理。</br>
                                </div>
                            </div>
                        </div>
                        <img :src="icon_4">
                    </el-col>
                </el-row>
            </div>
            <div class="wrapper__wpd relative">
                <el-row :gutter="30" class="relative water__box" style="z-index: 22">
                    <el-col :span="9">
                        <div>
                            <div class="wow animate__fadeInLeft" data-wow-delay=".2s" data-wow-duration="0.8s">
                                <div class="q_base__material--tit" style="margin-top: 200px;"><span>水路工艺</span></div>
                                <div class="q_base__material--des" style="font-size: 22px;margin-bottom: 20px">
                                    水路工艺，优质选材</div>
                                <div>食品级不锈钢管+多重降噪排水管强势减噪减震，确保安全环保、有效提升使用性能及品质。
                                </div>
                                <el-divider class="lins"></el-divider>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="9">
                        <img :src="icon_5">
                    </el-col>
                    <el-col :span="6">
                        <img :src="icon_6" class="bt">
                    </el-col>
                </el-row>
                <img :src="icon_7" class="ttb">
            </div>
            <div class="wrapper__wpd relative" style="margin-top: 140px">
                <el-row :gutter="30" class="relative water__box dl__box" style="z-index: 22">
                    <el-col :span="9">
                        <img :src="icon_8">
                    </el-col>
                    <el-col :span="6" class="relative" style="height: 750px">
                        <img :src="icon_9" class="bt">
                    </el-col>
                    <el-col :span="9">
                        <div>
                            <div >
                                <div class="wow animate__fadeInLeft" data-wow-delay=".2s" data-wow-duration="0.8s">
                                    <div class="q_base__material--tit" style="margin-top: 0px;"><span>电路工艺</span></div>
                                    <div class="q_base__material--des" style="font-size: 22px;margin-bottom: 0px">
                                        水路工艺，电路体系 ：拒绝蜘蛛网，一个“箱子”全搞定。
                                    </div>
                                    <div class="q_base__material--des" style="font-size: 22px;margin-top: 20px">
                                        小小等电位，轻松解决安全大隐患，防漏电、静电、雷电
                                    </div>
                                </div>
                                <div class="dl__right"><img :src="icon_10"></div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <div class="gray__bg" style="z-index: 11;left: 0;top: -80px;width: 34%;height: 238px"></div>

            </div>
            <div class="wrapper__wpd relative">
                <el-row :gutter="30" class="relative" style="z-index: 22">
                    <el-col :span="12">
                        <div style="width: 90%">
                            <div class="wow animate__fadeInLeft" data-wow-delay=".2s" data-wow-duration="0.8s">
                                <div class="q_base__material--tit"><span>吊顶工艺</span></div>
                                <div class="q_base__material--des" style="font-size: 22px">轻钢龙骨吊顶工艺体系</div>
                                <div class="q_base__material--des">吊顶选用欧标轻钢龙骨及配件，为环保与品质加分。配合独创式灯孔开孔工艺及无尘处理方式，石膏板罩面，杜绝扬尘，100%确保业主的健康。
                                </div>
                            </div>
                            <div class="q_base__material--img abs">
                                <img :src="icon_11">
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="q_base__material--imgbg">
                            <img :src="icon_12">
                        </div>
                    </el-col>
                </el-row>
                <div class="gray__bg" style="z-index: 11;right: 0;top: 50px;width: 40%;height: 255px"></div>
            </div>
            <div class="wrapper__w relative q__jj" >
                <el-row :gutter="0" style="margin-top: 40px;">
                    <el-col :span="12" class="jj__left">
                        <img :src="icon_13">
                    </el-col>
                    <el-col :span="12" class="jj__right relative">
                        <div>
                            <div style="margin-left: 13%;width: 56%;" class="wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s">
                                <div class="q_base__material--tit"><span>泥工工艺</span></div>
                                <div class="q_base__material--des" style="font-size: 22px;margin-bottom: 20px">
                                    专业化基层防水，确保万无一“湿”</br>
                                    瓷砖薄贴工艺，确保了瓷砖的铺贴寿命
                                </div>
                                <div>
                                    墙面铺贴瓷砖或石材时，墙面砖缝拼接处对应，且压向正确，增加观性。</br>
                                    瓷砖薄贴工艺，避免了瓷砖的脱落及开裂，确保了瓷砖的铺贴寿命。特别是解决了薄板砖一类的低吸水率砖的安全铺贴。
                                </div>
                            </div>
                        </div>
                        <img :src="icon_14">
                    </el-col>
                </el-row>
            </div>
            <div class="wrapper__wpd relative">
                <el-row :gutter="30" class="relative water__box" style="z-index: 22">
                    <el-col :span="9">
                        <div>
                            <div class="wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s">
                                <div class="q_base__material--tit" style="margin-top: 200px;"><span>木工工艺</span></div>
                                <div class="q_base__material--des" style="font-size: 22px;margin-bottom: 20px">
                                    首推无板化施工工艺，达到真正的牢固、绿色、无甲醛。</div>
                                <div>高耐板+轻钢龙骨的全新体系，在选材与工艺上，确保环保性与结构牢固度，从源头严控环保安全，无需再为装修中途做空气治理而担忧。
                                </div>
                                <el-divider class="lins"></el-divider>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="9">
                        <img :src="icon_16">
                    </el-col>
                    <el-col :span="6">
                        <img :src="icon_17" class="bt">
                    </el-col>
                </el-row>
                <img :src="icon_15" class="ttb">
            </div>
            <div class="wrapper__wpd relative" style="height: 581px">
                <el-row :gutter="30" class="relative water__box" style="z-index: 22;height: 581px">
                    <el-col :span="9">
                        <img :src="icon_19">
                    </el-col>
                    <el-col :span="6" class="relative" style="height: 581px;">
                        <img :src="icon_20" class="bt" style="left: 10px">
                    </el-col>
                    <el-col :span="9"  class="relative" style="height:581px;">
                        <div>
                            <div class="wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s">
                                <div class="q_base__material--tit" style="margin-top: 200px;"><span>油漆工艺</span></div>
                                <div class="q_base__material--des" style="font-size: 22px;margin-bottom: 20px"> 喷涂石膏砂浆工艺</div>
                                <div>
                                    <ul class="ul__disc">
                                        <li>环保材料，PH值中性，健康保障</li>
                                        <li>硬化过程微膨胀，无收缩后的裂纹，无空鼓</li>
                                        <li>石膏的呼吸功能，更好调节室内气候</li>
                                        <li>导热系数低，更好的保温性能</li>
                                        <li>基层牢固可靠（5-35mm一次成型）</li>
                                        <li>机械化施工，质量有保证</li>
                                        <li>成品结晶水含量高，防火性能更强</li>
                                        <li>容重低，大大降低建筑物承重，更有利于环保和可持续发展</li>
                                    </ul>
                                </div>

                            </div>

                        </div>
                        <el-divider class="lins absline"></el-divider>
                    </el-col>

                </el-row>
                <img :src="icon_18" class="ttb" style="width: 80%">
            </div>
            <div class="wrapper__wpd relative">
                <el-row :gutter="30" class="relative water__box" style="z-index: 22">
                    <el-col :span="9">
                        <div>
                            <div class="wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s">
                                <div class="q_base__material--tit" style="margin-top: 200px;"><span>项目验收</span></div>
                                <div class="q_base__material--des" style="font-size: 22px;margin-bottom: 20px">
                                    十大验收节点 保证工程质量
                                </div>
                                <div>房屋整体交接验收、图纸放样验收、机电隐蔽工程验收、防水分段验收、泥工、木工、油漆各阶段验收、各专业单位专检、竣工验收，材料分阶段验收贯穿整个过程。
                                </div>
                                <el-divider class="lins"></el-divider>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="9">
                        <img :src="icon_22">
                    </el-col>
                    <el-col :span="6">
                        <img :src="icon_23" class="bt">
                    </el-col>
                </el-row>
                <img :src="icon_21" class="ttb">
            </div>
            <div class="wrapper__wpd relative" style="height: 306px">
                <el-row :gutter="30" class="relative water__box" style="z-index: 22;height: 306px">
                    <el-col :span="12">
                        <img :src="icon_24">
                    </el-col>
                    <el-col :span="12"  class="relative" style="height:306px;">
                        <div>
                            <div style="width: 70%;margin: 0 auto;" class="wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s">
                                <div class="q_base__material--tit"><span>空气检测</span></div>
                                <div class="q_base__material--des" style="font-size: 22px;margin-bottom: 20px"> 欧标空气检测
                                </div>
                                <div>前瞻的居室健康环保意识，隐上在环保选材与独特工艺上花精力，无需做阶段性空气净化与治理。
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="wrapper__wpd qu__footer" style="background: #f1f1f1;padding-right: 0">
                <img :src="icon_25">
                <img :src="icon_26">
            </div>




        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import icon_stra from '@/assets/img/gj01.png'
    import icon_q01 from '@/assets/img/qit/banner.png'
    import icon_1 from '@/assets/img/qit/1.png'
    import icon_2 from '@/assets/img/qit/2.png'
    import icon_3 from '@/assets/img/qit/3.jpeg'
    import icon_4 from '@/assets/img/qit/4.png'
    import icon_5 from '@/assets/img/qit/5.png'
    import icon_6 from '@/assets/img/qit/6.png'
    import icon_7 from '@/assets/img/qit/7.png'
    import icon_8 from '@/assets/img/qit/8.png'
    import icon_9 from '@/assets/img/qit/9.png'
    import icon_10 from '@/assets/img/qit/10.png'
    import icon_11 from '@/assets/img/qit/11.png'
    import icon_12 from '@/assets/img/qit/12.png'
    import icon_13 from '@/assets/img/qit/13.jpeg'
    import icon_14 from '@/assets/img/qit/14.png'
    import icon_15 from '@/assets/img/qit/15.png'
    import icon_16 from '@/assets/img/qit/16.png'
    import icon_17 from '@/assets/img/qit/17.png'
    import icon_18 from '@/assets/img/qit/18.png'
    import icon_19 from '@/assets/img/qit/19.png'
    import icon_20 from '@/assets/img/qit/20.png'
    import icon_21 from '@/assets/img/qit/21.png'
    import icon_22 from '@/assets/img/qit/22.png'
    import icon_23 from '@/assets/img/qit/23.png'
    import icon_24 from '@/assets/img/qit/24.png'
    import icon_25 from '@/assets/img/qit/25.png'
    import icon_26 from '@/assets/img/qit/26.png'


    import NavSecond from '@/components/NavSecond'
    import Footer from '@/layouts/Footer'


    export default {
        name: 'Test',
        data (){
            return {
                icon_stra,icon_q01,icon_1,icon_2,icon_3,icon_4,icon_5,icon_6,icon_7,icon_8,icon_9,icon_10,icon_11,icon_12,icon_13,icon_14,icon_15,icon_16,icon_17,icon_18,icon_19,icon_20,icon_21,icon_22,icon_23,icon_24,icon_25,icon_26,
            }
        },
        components: {
            NavSecond,Footer
        },
        mounted() {
            this.$wow.init()
        },
    }
</script>
<style  lang="scss" scoped>
    .quality__content{
        line-height: 22px;
        letter-spacing: .5px;
        .gray__bg{
            z-index: 2;
            position: absolute;
            right: 0;
            top: 100px;
            width: 100%;
            height: 395px;
            background: #F1F1F1;
        }
        .qu_type, .q_base__material--tit{
            text-align: center;
            font-size: 36px;
            font-weight: bold;
            color: #010101;
            height: 200px;
            line-height: 250px;
            span{
                position: relative;
                &::after{
                    content: '';
                    display: block;
                    position: absolute;
                    left: 50%;
                    margin-left: -16px;
                    bottom: -20px;
                    width: 32px;
                    height: 4px;
                    background: #F55E1B;
                }
            }
        }
        .q_process__flow{
            height: 320px;
            margin-top: 100px;
            .qu_type{
                text-align: left;
                color: #fff;
                margin-left: 10%;
                height: auto;
                line-height: unset;
                .remd{
                    margin-top: 50px;
                    color: #fff;
                    font-size: 24px;
                    font-weight: 400;
                    line-height: 24px;
                }
            }
        }
        .q_base__material--tit{
            margin-top: 70px;
            font-size: 36px;
            font-weight: bold;
            color: #010101;
            line-height: unset;
            height: auto;
            text-align: left;
            span::after{
                content: '';
                display: block;
                position: absolute;
                left: 0%;
                margin-left: 0;
                bottom: -20px;
                width: 32px;
                height: 4px;
                background: #F55E1B;
            }
        }
        .q_base__material--des{
            margin-top: 50px;
            font-size: 16px;
            font-weight: 400;
            color: #000000;
            line-height: 24px;

        }
        .q_base__material--imgbg{
            position: relative;
            z-index: 22;
            margin-top: 130px;
            img{
                width: 85%;
                object-fit: cover;
                height: 380px;
                display: block;
            }
        }
        .q_base__material--img{
            margin-top: 145px;
            text-align: right;
            img{
                width: 286px;
            }
            &.abs{
                position: absolute;
                bottom: 10px;
                left: 15px;
            }
        }
        .q__jj{
            height: 380px;
            background: #F1F1F1;
            .jj__left{
                img{
                    width: 100%;
                    height: 380px;
                    display: block;
                }
            }
            .jj__right{
                img{
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 178px;
                    height: 380px;
                    display: block;
                }
            }
        }
        .water__box{
            height: 580px;
            margin-top: 120px;
            img{
                display: block;
                width: 100%;
            }
            .bt,.ttb{
                position: absolute;
                bottom: 15px;
                right: 0;
                width: 286px;
            }
        }
        .ttb{
            position: absolute;
            top: 0;
            width: 90%;
            left:10%;
            height: 128px;
        }
        .lins{
            margin-top: 150px;
            height: 2px;
            background-color: #F15315;
            &.absline{
                position:absolute;
                right: 0;
                bottom: -10px;
            }
        }
        .dl__box{
            height: 750px;
            .dl__right{
                position: absolute;
                right: 15px;
                bottom: 60px;
                img{
                    width: 286px;
                    height: 216px;
                    display: block;
                }
            }
        }
        .qu__footer{
            overflow: hidden;
            width: 90%;
            img{
                float: left;
                width: 213px;
                display: block;
                margin-right: 14%;
            }
        }
    }
    .ul__disc {
        li{
            list-style: disc;
            margin-left: 20px;
        }
    }

</style>
